module.exports = __webpack_public_path__ + "static/img/icon-pro2.20bcca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-pro2.jpg
// module id = U9Um
// module chunks = 21